/*
Quick ref:
    0 – red
    60 – yellow
    120 – green
    180 – turquoise
    240 – blue
    300 – pink
    360 – red
*/
export const getColorForPercentage = (percent: number, start: number = 0, end: number = 360) => {
  const a = percent / 100;
  const b = (end - start) * a;
  const c = b + start;

  // Return a CSS HSL string
  return 'hsl(' + c + ', 100%, 50%)';
  // or output as hex if preferred
};


export const txtColorForBackground=(color:string)=>{

    // Function to calculate brightness (0-255)
    const getBrightness = (hexColor: string): number => {
      // Handle various color formats
      let r = 0, g = 0, b = 0;

      // Remove the hash at the start if it exists
      const formattedColor = hexColor.startsWith('#') ? hexColor.slice(1) : hexColor;

      // Handle 6 digit hex
      if (formattedColor.length === 6) {
        r = parseInt(formattedColor.substring(0, 2), 16);
        g = parseInt(formattedColor.substring(2, 4), 16);
        b = parseInt(formattedColor.substring(4, 6), 16);
      }
      // Handle 3 digit hex
      else if (formattedColor.length === 3) {
        r = parseInt(formattedColor[0] + formattedColor[0], 16);
        g = parseInt(formattedColor[1] + formattedColor[1], 16);
        b = parseInt(formattedColor[2] + formattedColor[2], 16);
      }
      // Handle rgb format
      else if (formattedColor.startsWith('rgb')) {
        const rgbValues = formattedColor.match(/\d+/g);
        if (rgbValues && rgbValues.length >= 3) {
          r = parseInt(rgbValues[0], 10);
          g = parseInt(rgbValues[1], 10);
          b = parseInt(rgbValues[2], 10);
        }
      }

      // Calculate brightness using the formula: (0.299*R + 0.587*G + 0.114*B)
      // This formula gives more weight to green as human eyes are more sensitive to it
      return (0.299 * r + 0.587 * g + 0.114 * b);
    };

    // Threshold for determining if a color is dark (0-255)
    const brightnessThreshold = 128;

    // If brightness is less than threshold, color is considered dark
    return getBrightness(color) < brightnessThreshold ? 'white' : 'black';
}

/**
 * Turn a color into its rgba() form with the given alpha.
 * Returns an empty string when there is no color to work with, so callers can
 * simply skip the style instead of falling back on an arbitrary one.
 */
export const toRgba = (color: string | null | undefined, alpha: number): string => {
    if (!color) {
        return '';
    }
    const trimmed = color.trim();

    // already an rgb()/rgba(): keep the channels, apply the alpha
    if (trimmed.startsWith('rgb')) {
        const channels = trimmed.match(/[\d.]+/g);
        if (!channels || channels.length < 3) {
            return '';
        }
        return 'rgba(' + channels[0] + ', ' + channels[1] + ', ' + channels[2] + ', ' + alpha + ')';
    }

    const hex = trimmed.startsWith('#') ? trimmed.slice(1) : trimmed;
    let r = 0;
    let g = 0;
    let b = 0;
    if (hex.length === 6) {
        r = parseInt(hex.slice(0, 2), 16);
        g = parseInt(hex.slice(2, 4), 16);
        b = parseInt(hex.slice(4, 6), 16);
    } else if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
    } else {
        return '';
    }
    if (isNaN(r) || isNaN(g) || isNaN(b)) {
        return '';
    }
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
};
